// =============================================================================
// Copyright   : 2018 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : color maps from https://matplotlib.org/users/colormaps.html
/*
from matplotlib import pyplot as plt
for n in 'Dark2', 'Set1', 'Set2', 'Set3':
    print('export const %s = [' % n)
    for r, g, b in plt.get_cmap(n).colors:
        print("  '#%0.2X%0.2X%0.2X', "  % (int(r * 255), int(g * 255), int(b * 255)))
    print(']')
*/
// =============================================================================

export const Dark2 = [
  '#1B9E77',
  '#D95F02',
  '#7570B3',
  '#E7298A',
  '#66A61E',
  '#E6AB02',
  '#A6761D',
  '#666666',
]
export const Set1 = [
  '#E41A1C',
  '#377EB8',
  '#4DAF4A',
  '#984EA3',
  '#FF7F00',
  '#FFFF33',
  '#A65628',
  '#F781BF',
  '#999999',
]
export const Set2 = [
  '#789aeb',
  '#A0E32D',
  '#E3725B',
  '#FFD92F',
  '#E35B92',
  '#60577D',
  '#39C5E3',
  '#B3B3B3',
]
export const Set3 = [
  '#8DD3C7',
  '#FFFFB3',
  '#BEBADA',
  '#FB8072',
  '#80B1D3',
  '#FDB462',
  '#B3DE69',
  '#FCCDE5',
  '#D9D9D9',
  '#BC80BD',
  '#CCEBC5',
  '#FFED6F',
]

export const statusColors = {
  success: '#78e08f',
  success2: '#b8e994',
  success3: '#81c784',
  error: '#ED4C67',
  error2: '#ff7675',
  error3: '#d32f2f',
  warning: '#ff9800',
  warning2: '#fdcb6e',
  warning3: '#e17055',
  neutral: '#789aeb',
  neutral2: '#74b9ff',
  neutral3: '#8C8AFF',
  neutral4: '#7D7BCF',
  inactive: '#a8a8a8',
  inactive2: '#c2c2c2',
}

export const darkColors = Dark2.concat(Set1)
export const lightColors = Set2.concat(Set3)
